// extracted by mini-css-extract-plugin
module.exports = {"heading":"ExpertInsights_heading__bVC_b","sections":"ExpertInsights_sections__i3wKe","chat":"ExpertInsights_chat__1clD0"};